import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AssociationStatusConfiguration } from '@shared/models';

import { ApiService } from './api.service';

@Injectable()
export class AssociationConfigurationService extends ApiService<AssociationStatusConfiguration> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'associations/';
  }
}
